import * as React from 'react';
import { authProvider } from 'dependencies/auth';

import styles from './case-password.scss';
import { ButtonCallToAction } from 'ui';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux';
import { caseTranslations } from 'app/area/case/constants';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { ComponentType, PropsWithChildren } from 'react';

interface CasePasswordState {
  casePassword: string;
  passwordSubmitted: boolean;
}

export const withCasePassword = (Component: ComponentType<PropsWithChildren<unknown>>): ComponentType<PropsWithChildren<any>> => {
  class CasePassword extends React.Component<any, CasePasswordState> {
    public static statePath: string = STATE.case;

    public constructor(props: any) {
      super(props);

      this.state = {
        casePassword: authProvider.getAuthorization() || '',
        passwordSubmitted: !!authProvider.getAuthorization()
      };
    }

    private onOpenCase = () => {
      authProvider.setAuthorization(this.state.casePassword);

      this.setState({
        passwordSubmitted: true
      });
    };

    private onChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event && event.target && event.target.name) {
        this.setState({
          [event.target.name]: event.target.value
        } as any);
      }
    };

    public render() {
      const { casePassword, passwordSubmitted } = this.state;
      const { translation } = this.props;

      if (passwordSubmitted) {
        return <Component {...this.props} />;
      }

      return (
        <MainGridContainer className={`${styles.enterPasswordPanel}`}>
          <div className={`${styles.openCasePanel}`}>
            <div>
              <h1>{translation.public_enter_password}</h1>
              <div className={`input-wrapper ${styles.inputSection}`}>
                <form onSubmit={this.onOpenCase} id="openCaseForm">
                  <input
                    id="casePassword"
                    name="casePassword"
                    className={styles.inputElement}
                    type="password"
                    placeholder={translation.public_case_password}
                    value={casePassword}
                    onChange={this.onChangeValue}
                  />
                  <ButtonCallToAction
                    onClick={this.onOpenCase}
                    id="openCaseButton"
                    disabled={!casePassword}
                    className={`${styles.btnOpenCase}`}
                  >
                    {translation.public_open_case}
                  </ButtonCallToAction>
                </form>
              </div>
            </div>
          </div>
        </MainGridContainer>
      );
    }
  }

  return containerFactory(
    CasePassword,
    undefined,
    undefined,
    caseTranslations
  );
};
